export const FLW28 = {
	defaultValues: {
		height: 1000,
		width: 1000,
		windowQuantity: 1,
		ug: {
			glass2: 1.1,
			panel: 1.1
		},
		psi: {
			glass2: 0.045,
			panel: 0.03
		},
		isolation: false,
		glassThickness: 28,
		middleMullion: false,
		glassTypes: 1
	},
	fixedValues: {
		middleMullion: true,
		isolation: false,
		glassTypes: [
			{
				name: 'Paneele',
				value: 0
			},
			{
				name: '2-fach-Glas',
				value: 1
			}
		],
		ug2: [{value: 1}, {value: 1.1}, {value: 1.2}, {value: 1.3}, {value: 1.4}],
		up: [
			{
				name: 'Vakuum-Dämmkern',
				value: 0.3
			},
			{
				name: 'PU-Dämmkern',
				value: 0.83
			},
			{
				name: 'Mineralfaser-Dämmkern',
				value: 1.13
			},
			{
				name: 'XPS-Dämmkern',
				value: 1
			}
		],
		psi: {
			ug2: [
				{
					name: 'Thermix TX Pro:',
					value: 0.049
				}, {
					name: 'Thermix Schwarz:',
					value: 0.045
				},{
					name: 'Super Spacer TriSeal / T-Spacer Premium Plus:',
					value: 0.042
				}, {
					name: 'Ultimate SwissPacer:',
					value: 0.036
				}, {
					name: 'Advance SwissPacer:',
					value: 0.047
				}, {
					name: 'Multitech:',
					value: 0.035
				}, {
					name: 'TGI-Spacer Precision:',
					value: 0.036
				}, {
					name: 'Alu:',
					value: 0.111
				}
			],
			up: [
				{ name: 'Vakuum-Dämmkern', value: 0.01},
				{ name: 'PU-Dämmkern', value: 0.02},
				{ name: 'Mineralfaser-Dämmkern', value: 0.03},
				{ name: 'XPS-Dämmkern', value: 0.02}
			]
		}
	},
	edgeTop: {
		W_m2K: 4.262,
		width: 43
	},
	edgeSide: {
		W_m2K: 4.092,
		width: 62
	},
	edgeBottom: {
		W_m2K: 4.492,
		width: 43
	},
	louvre: {
		W_m2K: 3.693,
		width: 43
	},
	middleMullion: {
		W_m2K: 4.16,
		width: 104,
		min: 700,
		max: 3982
	},
	windowWidth: {
		min: 300,
		max: 2000
	},
	windowHeight: {
		min: 250,
		max: 3000
	},
	louvreHeight: {
		min: 170,
		max: 344
	},
	edgeWidth: 40,
	gabDimensions: {
		side: 2.5,
		top: 3.5,
		middle: 4,
		bottom: 5.5
	},
	allowance: {
		width: 23,
		height: 19
	},
	area: {},
	cvReference85deg: 0.61,
	cvFactors: {cv1: 0.02, cv2: 0.02, cv3: 0.04},
	dimensionsOpenLouvre: {
		sideMullion: 42,
		profileTop: 27,
		profileBottom: 32,
		louvre: 34,
		mm: 64
	},
	windLoadCalculation: {
		wl1500: [
			{
				hMax: 300
			}
		],
		wl2000: [
			{
				wMax: 1916,
				hMax: 300,
				aMax: 0.57
			},
		],
		wl2250: [
			{
				wMax: 1786,
				hMax: 300,
				aMax: 0.54
			},
			{
				wMax: 1916,
				hMax: 279,
				aMax: 0.53
			}
		],
		wl2500: [
			{
				wMax: 1596,
				hMax: 300,
				aMax: 0.48
			},
			{
				wMax: 1916,
				hMax: 250,
				aMax: 0.48
			}
		],
		wl2750: [
			{
				wMax: 1436,
				hMax: 300,
				aMax: 0.43
			},
			{
				wMax: 1916,
				hMax: 225,
				aMax: 0.43
			}
		],
		wl3000: [
			{
				wMax: 1306,
				hMax: 300,
				aMax: 0.39
			},
			{
				wMax: 1916,
				hMax: 205,
				aMax: 0.39
			},
			{
				wMax: 1116,
				hMax: 344,
				aMax: 0.39
			}
		]
	}

};

